<template>
  <q-dialog ref="dialogRef" :position="dialogPosition">
    <q-card class="q-dialog-plugin">
      <ModalHeader header="Record Meeting" @on-close="onDialogHide" />

      <q-card-section class="q-pt-none">
        <BrandInput
          dense
          label="Meeting Link"
          v-model.trim="meetingUrl"
          :rules="[(val) => isValidUrl(val) || 'Invalid meeting URL']"
        />
        <BrandInput label="Name (optional)" v-model.trim="recordingName" />
        <a
          href="https://sales.voizor.com/zoom-integration"
          target="_blank"
          class="text-blue-7 text-underline text-right"
        >
          Connect zoom
        </a>
      </q-card-section>
      <q-card-actions vertical>
        <PrimaryButton
          :loading="loading"
          @click="requestBot(meetingUrl, recordingName)"
          :disable="!meetingUrl"
        >
          Request Join
        </PrimaryButton>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { ref } from 'vue';
import ModalHeader from './ModalHeader.vue';
import { useDialogPluginComponent } from 'quasar';
import { useMobile } from '@/hooks/useMobile';
import BrandInput from '../brand/BrandInput.vue';
import PrimaryButton from '../brand/PrimaryButton.vue';
import { useStore } from 'vuex';
import { SendError, SendSuccess } from '@/helpers';
import { Sentry } from '@/vendors/Sentry';

const recordingName = ref('');
const meetingUrl = ref('');
const loading = ref(false);

const $store = useStore();
const { dialogRef, onDialogHide } = useDialogPluginComponent();
const { dialogPosition } = useMobile();

const requestBot = async (meetingUrl, recordingName) => {
  loading.value = true;
  try {
    const data = await $store.dispatch('requestBot', {
      name: recordingName,
      meetingUrl,
    });
    SendSuccess('Your assistant should join the meeting shortly');
    loading.value = false;
    onDialogHide();
    return data;
  } catch (err) {
    Sentry.captureException(err);
    SendError(err);
  } finally {
    loading.value = false;
  }
};
function isValidUrl(url) {
  return /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?(\?[=&\w\.-]*)?$/.test(url);
}
</script>
